import { ApolloClient, NormalizedCacheObject, InMemoryCache, HttpLink } from '@apollo/client';
import { createPersistedQueryLink } from '@apollo/client/link/persisted-queries';
import { onError } from '@apollo/client/link/error';
import { sha256 } from 'crypto-hash';

const serverUrl = process.env.REACT_APP_IS_LOCAL
  ? 'http://localhost:3001/api/graphql'
  : '/api/graphql';

const cache = new InMemoryCache({});

const link = new HttpLink({
  uri: serverUrl,
  credentials: process.env.REACT_APP_IS_LOCAL ? 'include' : 'same-origin',
});

const errorLink = onError(({ graphQLErrors, networkError }) => {
  if (graphQLErrors) {
    graphQLErrors.forEach(({ message, locations, path }) =>
      console.error(`[GraphQL error]: Message: ${message}, Location: ${locations}, Path: ${path}`)
    );
  }

  if (networkError) {
    console.error(`[Network error]: ${networkError}`);
  }
});

const persistedLink = createPersistedQueryLink({ useGETForHashedQueries: true, sha256 })
  .concat(errorLink)
  .concat(link);

export const apolloClient: ApolloClient<NormalizedCacheObject> = new ApolloClient({
  link: process.env.REACT_APP_IS_LOCAL ? link : persistedLink,
  defaultOptions: {
    query: {
      errorPolicy: 'all',
    },
  },
  connectToDevTools: process.env.NODE_ENV !== 'production',
  cache,
});
